var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-member-add"},[_c('center-add-title',[_vm._v(_vm._s(_vm.$t("message.cmember.addTitle")))]),_c('div',{staticClass:"center-member-add-content"},[_vm._t("addForm")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }